<template>
  <div>
    <!-- 第一部分 -->
    <div class="banner">
      <img
        src="../assets/SB_Banner.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
    </div>

    <!-- 第二部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">品牌故事</span>
              <span class="title_en"> Brand stories </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 900px">
          <img
            src="../assets/SB_banner01.jpg"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            SmartBones深知无论多么挑嘴的狗狗都无法拒绝美味的肉，SmartBones创新性地将美味的肉藏
            入洁牙层，狗狗想吃到肉，必然咀嚼外面的洁牙层。一根符合自然法则的洁牙骨就这样诞生了！
            SmartBones认为狗狗不仅仅是宠物，更是我们家人！
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            我们严格的遵循美国FDA准则来监管我们的产品质量和生产流程。更多信息请关注公司网站及
            SmartBones微信公众号。
          </p>
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">产品结构</span>
              <span class="title_en"> Product Structure</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 900px">
          <img
            src="../assets/SB_banner02.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>

    <!-- 第四部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">产品特点</span>
              <span class="title_en"> Product Features </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 900px">
          <img
            src="../assets/SB_banner03.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 20px; color: #2963a4">
              SmartBones系列产品不含牛皮，但具备纯牛皮咬胶的所有好处</strong
            ><br /><br />
            根据七彩神仙的营养需求和进食习惯而特别研究的高品质的颗粒饲料。
            ·在满足狗狗天生咬嚼的本性的同时，易于吃完<br />
            · 多种口味可供选择<br />
            · 分牛肉、鸡肉、花生、土豆四个口味<br /><br />
            <strong>用料精良</strong><br />
            · 用真正的牛肉(或鸡肉或花生或土豆)和蔬菜制成<br />
            · 无生皮配方，避免对牛皮过敏<br /><br />
            <strong>易于消化</strong><br />
            · 富含多种维生素和矿物质，营养全面<br />
            · 功能系列添加了独特元素，有助于辅助特殊功能的实现<br />
            · 长期咀嚼，有助于保持爱犬牙齿健康<br />
            ·不同的大小适合不同的狗狗
          </p>
        </div>
      </div>
    </div>

    <!-- 底部栏 -->
    <foot></foot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  //   border-bottom: 1px solid #2963a4;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  //   .title_num {
  //     font-size: 80px;
  //     font-weight: 500;
  //     color: #2963a4;
  //     margin-right: 5px;
  //   }
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}

.second_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}
</style>